// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import LoadingBar from 'react-redux-loading-bar'
import Cookies from 'js-cookie'
import zenscroll from 'zenscroll'

// Internal Dependencies:
import TicketRow from './TicketRow'
import PlusCircle from 'components/svg/plus-circle.svg'
import IconSearch from 'components/svg/search.svg'
import IconClose from 'components/svg/close-circle-outline.svg'
import { loop } from 'utilities/objects'
import { loopArray } from 'utilities/arrays'

// Redux:
import * as reduxTickets from 'actions/tickets'

class Tickets extends React.Component {
	constructor() {
		super()

		const perPage = Cookies.get( 'tickets_per_page' ) || 10
		let pagesNumber = 1

		this.state = {
			perPage,
			pagesNumber,
			currentPage: 1,
			filter: '',
			orderBy: 'id',
			order: 'desc',
			results: [],
			showSearch: false,
			searchTerm: ''
		}
		this.ticketsRef = React.createRef()
	}

	componentDidMount() {
		this.getResults()

		this.interval = setInterval( () => {
			this.getResults()
		}, 1000 * 60 )
	}

	componentWillUnmount() {
		clearInterval( this.interval )
	}

	handleChangePerPage = ( e ) => {
		const value = parseInt( e.target.value, 10 )

		Cookies.set( 'tickets_per_page', value )

		this.setState( {
			perPage: value
		}, () => {
			this.getResults()
		} )
	}

	handleClickPage = ( e ) => {
		this.setState( {
			currentPage: parseInt( e.currentTarget.getAttribute( 'data-page' ), 10 )
		}, () => {
			this.getResults()
		} )

		zenscroll.to( this.ticketsRef.current, 400 )
	}

	handleChangeFilter = ( e ) => {
		this.setState( {
			filter: e.target.value
		}, () => {
			this.getResults()
		} )
	}

	handleClickSort = ( e ) => {
		const orderByNew = e.currentTarget.getAttribute( 'data-sort-key' )
		const { orderBy, order } = this.state

		// Switch direction on subsequent clicks:
		let newOrder = orderBy == orderByNew ? 'opposite' : 'desc'

		if ( 'opposite' == newOrder ) {
			newOrder = 'desc' == order ? 'asc' : 'desc'
		}

		this.setState( {
			orderBy: orderByNew,
			order: newOrder
		}, () => {
			this.getResults()
		} )
	}

	toggleSearch = () => {
		this.setState( {
			showSearch: ! this.state.showSearch
		} )
	}

	updateSearch = ( e ) => {
		this.setState( {
			searchTerm: e.target.value
		}, () => {
			this.getResults()
		} )
	}

	getResults = () => {
		const { dispatch, receivedTickets, ticketsById, accountData } = this.props
		const { perPage, currentPage, filter, orderBy, order, showSearch, searchTerm } = this.state
		let results = [],
			i = 0

		const startNumber = perPage * ( currentPage - 1 ) + 1
		const endNumber = startNumber + perPage
		const ticketsKeys = Object.keys( ticketsById ).slice( startNumber - 1 )
		const searchTermLower = searchTerm.toLowerCase()

		dispatch( reduxTickets.getTickets( {
			currentPage,
			perPage,
			filter,
			orderBy,
			order,
			search: showSearch ? searchTerm : ''
		} ) )
	}

	renderPagination = () => {
		const { pagesNumber } = this.props
		const { currentPage } = this.state

		if ( pagesNumber <= 1 ) {
			return null
		}

		const markup = [ ...Array( pagesNumber ) ].map( ( e, i ) => {
			i++

			if (
				i > 3 && // Show first 3.
				i <= ( pagesNumber - 3 ) && // Show last 3.
				i != ( pagesNumber / 2 ) && // Show middle.
				i != currentPage && // Show this page.
				i != currentPage + 1 && // Show next page.
				i != currentPage - 1 // Show previous page.
			) {
				return null
			}

			var className = currentPage == i ? '-page is-active' : '-page'

			return (
				<button className={ className } onClick={ this.handleClickPage } data-page={ i } key={ i }>
					{ i }
				</button>
			)
		} )

		const prevClass = currentPage > 1 ? '-prev' : '-prev is-disabled'
		const nextClass = currentPage < pagesNumber ? '-next' : '-next is-disabled'

		return (
			<div className="-pagination">
				<button className={ prevClass } onClick={ this.handleClickPage } data-page={ currentPage - 1 }></button>

				{ markup }

				<button className={ nextClass } onClick={ this.handleClickPage } data-page={ currentPage + 1 }></button>
			</div>
		)
	}

	renderFilter = () => {
		const { ticketsById } = this.props
		const { filter } = this.state

		return (
			<div className="-filter">
				<h3>Filter by:</h3>

				<div className="form-select-dropdown">
					<div className="form-select-dropdown-inner">
						<select onChange={ this.handleChangeFilter } value={ filter }>
							<option value="">All</option>
							<option value="new">New</option>
							<option value="in-progress">In Progress</option>
							<option value="resolved">Resolved</option>
							<option value="awaiting-info">Awaiting information</option>
						</select>
					</div>
				</div>
			</div>
		)
	}

	renderRows = () => {
		const { ticketsById } = this.props
		let markup = []

		if ( ! ticketsById || ! Object.keys( ticketsById ).length ) {
			return null
		}

		loop( ticketsById, ( key, item ) => {
			markup.push( [
				<TicketRow key={ item.id } itemId={ item.id } />,

				<tr className="-ticket-row-space" key={ `${key}-space` }>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
					<td></td>
				</tr>
			] )
		} )

		return markup
	}

	render() {
		const { receivedTickets, initialReceivedTicketsCount, ticketsById, ticketsCount, accountData } = this.props
		const { perPage, currentPage, orderBy, order, filter, showSearch, searchTerm } = this.state

		if ( ! receivedTickets ) {
			return null
		}

		if ( ! initialReceivedTicketsCount ) {
			return (
				<div className="page-plain">
					<div className="-inner">
						<div className="-no-results-new-claim">
							<Link className="button is-large" to="/register"><PlusCircle /><span>Register a new claim</span></Link>
						</div>
					</div>
				</div>
			)
		}

		let classSearch = showSearch ? '-search is-active' : '-search'
		let classButtons = showSearch ? '-buttons' : '-buttons is-active'

		return (
			<div className="tickets" ref={ this.ticketsRef }>
				<div className="-inner">
					<div className="-header">
						<div className="-inner">
							<h2>All Tickets</h2>

							<div className={ classSearch }>
								<div className="-inner">
									<IconSearch />
									<input type="text" value={ searchTerm } onChange={ this.updateSearch } />

									<button type="button" onClick={ this.toggleSearch }>
										<IconClose />
									</button>
								</div>
							</div>

							<div className={ classButtons }>
								{ accountData.is_admin &&
									<a href="/wp-admin" className="button">
										<span>Admin</span>
									</a>
								}

								{ accountData.is_admin &&
									<Link to="/contacts" className="button">
										<span>New Customer Registrations</span>
									</Link>
								}

								<button type="button" className="button" onClick={ this.toggleSearch }>
									<IconSearch />
									<span>Search</span>
								</button>

								<Link to="/new-claim" className="button">
									<PlusCircle />
									<span>New Warranty Claim</span>
								</Link>
							</div>
						</div>
					</div>

					<div className="-content">
						<table className="-tickets-table">
							<thead>
								<tr className="-head-row">
									<th><span className={ `is-${order}` + ( orderBy == 'id' ? ' is-active' : '' ) } onClick={ this.handleClickSort } data-sort-key="id">Ticket#</span></th>
									<th><span className={ `is-${order}` + ( orderBy == 'store' ? ' is-active' : '' ) } onClick={ this.handleClickSort } data-sort-key="store">Store</span></th>
									<th><span className={ `is-${order}` + ( orderBy == 'customer' ? ' is-active' : '' ) } onClick={ this.handleClickSort } data-sort-key="customer">Customer</span></th>
									<th><span className={ `is-${order}` + ( orderBy == 'date_received' ? ' is-active' : '' ) } onClick={ this.handleClickSort } data-sort-key="date_received">Date Received</span></th>
									<th><span className={ `is-${order}` + ( orderBy == 'days_since' ? ' is-active' : '' ) } onClick={ this.handleClickSort } data-sort-key="days_since">Days Since Claim</span></th>
									<th><span className={ `is-${order}` + ( orderBy == 'date_updated' ? ' is-active' : '' ) } onClick={ this.handleClickSort } data-sort-key="date_updated">Last Updated</span></th>
									<th></th>
									<th></th>
									<th>Status</th>
									<th className="-th-filter">
										{ accountData.is_staff && this.renderFilter() }
									</th>
								</tr>
							</thead>

							<tbody>
								{ this.renderRows() }
							</tbody>
						</table>

						<div className="data-nav">
							<div className="-per-page">
								<div className="form-select-dropdown">
									<select onChange={ this.handleChangePerPage } value={ perPage }>
										<option value="10">10</option>
										<option value="25">25</option>
										<option value="50">50</option>
									</select>
								</div>
							</div>

							{ this.renderPagination() }
						</div>
					</div>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		receivedTickets: state.tickets.receivedTickets,
		initialReceivedTicketsCount: state.tickets.initialReceivedTicketsCount,
		ticketsById: state.tickets.ticketsById,
		ticketsCount: state.tickets.ticketsCount,
		pagesNumber: state.tickets.ticketsMaxPages,
		updateState: state.tickets.updateState,
		accountData: state.user.accountData
	}
}

export default connect( mapStateToProps )( Tickets )
